export const LOGIN_PROMPT_KEY = 'login_prompt';
